import React, { useState, useEffect } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';

import axios from 'axios';

// CSS styling
const styles = {
    body: {
        fontFamily: 'Arial',
        color: '#122e4d',
        background: '#cedded',
    },
    input: {
        border: '4px solid #122e4d',
        width: '40%',
        height: '50px',
        borderRadius: '10px',
        fontSize: '20px',
    },
    button: {
        fontSize: '20px',
        borderRadius: '10px',
        border: '1px solid #122e4d',
    },
    stringEmbedded: {
        maxWidth: '100%', // Restrict the width to the parent's width
        overflow: 'auto', // Allow scrolling if content is larger than the div
    },
    card: {
        position: 'relative',
        width: '100%',  // or any specific size or max-width you want
        height: 'auto', // or any specific size or max-height you want
        overflow: 'hidden',
    },
    stringContainer: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
    },
};

export default function Component(props) {
    const { ...rest } = props;

    // Chakra Color Mode
    const cardColor = useColorModeValue('white', 'navy.700');
    const cardShadow = useColorModeValue(
        '0px 18px 40px rgba(112, 144, 176, 0.12)',
        'unset'
    );

    const [imageBase64, setImageBase64] = useState("");
    const [error, setError] = useState(null); // Initialize error state

    const [text, setText] = useState('');

    const sendRequestToString = () => {
        const proteins = text ? text.split(',') : ['GLI3']; // Default value

        if (window.getSTRING) {
            window.getSTRING('https://string-db.org', {
                species: '9606',
                identifiers: proteins,
                network_flavor: 'confidence',
                caller_identity: 'www.awesome_app.org',
            });
        }
    };

    useEffect(() => {
        // Check if selectedOption is not null and has a value field
        if (props.selectedOption && props.selectedOption.value) {
            // Use the selectedOption.value in the API URL
            // const apiUrl = `http://localhost:8000/api/get-crosstalk-network/?project=${props.selectedOption.value}`;
            // const apiUrl = `http://localhost:8000/api/get-crosstalk-enrichment/?project=${props.selectedOption.value}`;
            // const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
            // const apiUrl = `${api_host}/api/get-crosstalk-network/?project=${props.selectedOption.value}`;


            // axios.get(apiUrl)
            //     .then(response => {
            //         setImageBase64(response.data.image_base64);
            //     })
            //     .catch(err => {
            //         setError("Failed to fetch image."); // Set error state
            //         console.error("Error fetching image: ", err);
            //     });

            const script = document.createElement('script');
            script.src = 'https://string-db.org/javascript/combined_embedded_network_v2.0.4.js';
            document.body.appendChild(script);

            // Execute function once component is mounted
            sendRequestToString();

            return () => {
                // Cleanup - Remove the script when component is unmounted
                document.body.removeChild(script);
            };
        }
    }, [props.selectedOption]);

    return (
        <Card p='20px' align='center' direction='column' w='100%' style={styles.card}{...rest}>
            <div className="App">
                <Box mb={4}>
                    <h3>Positive correlation network of glycoproteins and phosphoproteins</h3>
                </Box>
                {/* {imageBase64 && <img src={`data:image/jpeg;base64,${imageBase64}`} alt="description" />} */}
                <div style={styles.body}>
                    <center>

                        <h3>Query me: (one human protein or multiple space-separated proteins)</h3>
                        <input
                            type="text"
                            placeholder="GLI3"
                            style={styles.input}
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        />
                        <br />
                        <br />
                        <button style={styles.button} onClick={sendRequestToString}>
                            Go!
                        </button>
                        <h3>Network:</h3>
                        <div id="stringEmbedded" style={styles.stringEmbedded} className="stringContainer" ></div>
                    </center>
                </div>
                {error && <p>{error}</p>} {/* Display error message */}
            </div>
        </Card>
    );
}
